import { useState, useCallback } from 'react';
import { CallbackRef, useCombineCallbackRefs } from 'app/utils/react';
import useOnResize from 'app/components/layout/useOnResize';

export interface ISize {
  width: number;
  height: number;
}

export default function useMeasure(): [
  ISize,
  CallbackRef,
] {
  const [size, setSize] = useState({ width: 0, height: 0 });

  const measureSize = useCallback((node: HTMLElement | null) => {
    setSize(prevSize => {
      const width = node?.offsetWidth ?? 0;
      const height = node?.offsetHeight ?? 0;

      return (width !== prevSize.width || height !== prevSize.height) ? {
        width,
        height,
      } : prevSize;
    });
  }, []);

  // 1. Measure size when element resizes
  const onResizeCallbackRef = useOnResize(node => {
    measureSize(node);
  });

  // 2. Measure size when the element is mounted.
  const elementCallbackRef: CallbackRef = useCallback(node => {
    measureSize(node);
  }, [measureSize]);

  const measureRef = useCombineCallbackRefs([elementCallbackRef, onResizeCallbackRef]);

  return [size, measureRef];
}
